import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import blogApi from '../api/blogApi';
import { useAuth } from '../context/AuthContext';

const PostEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  useEffect(() => {
    blogApi.get(`/api/blog/posts/${id}/`)
      .then(res => {
        setTitle(res.data.title);
        setContent(res.data.content);
      })
      .catch(err => {
        console.error('게시글 불러오기 실패:', err);
        alert('게시글을 불러오지 못했습니다.');
      });
  }, [id]);

  const handleSubmit = async () => {
    try {
      await blogApi.put(`/api/blog/posts/${id}/`, { title, content });
      alert('게시글이 수정되었습니다.');
      navigate(`/posts/${id}`);
    } catch (err) {
      console.error(err);
      alert('수정 실패: ' + (err.response?.data?.detail || '서버 오류'));
    }
  };

  if (!isLoggedIn) return <div className="p-8">로그인이 필요합니다.</div>;

  return (
    <div className="max-w-3xl mx-auto p-8">
      <h2 className="text-2xl font-bold mb-6">게시글 수정</h2>
      <input
        type="text"
        className="w-full border px-4 py-2 mb-4 rounded"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
      <textarea
        className="w-full border px-4 py-2 h-48 mb-4 rounded"
        value={content}
        onChange={(e) => setContent(e.target.value)}
      ></textarea>
      <div className="flex gap-2">
        <button
          onClick={handleSubmit}
          className="bg-[#3B82F6] text-white px-6 py-2 rounded hover:bg-blue-700"
        >
          저장
        </button>
        <button
          onClick={() => navigate(-1)}
          className="bg-gray-300 text-gray-800 px-6 py-2 rounded hover:bg-gray-400"
        >
          취소
        </button>
      </div>
    </div>
  );
};

export default PostEdit;
